import styles from "./soon-feature-modal.module.scss";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import React from "react";
import FilledButton from "@/components/common/filled-button";

interface SoonFeatureModalProps {
  featureName: string;
}

const SoonFeatureModal = ({ featureName }: SoonFeatureModalProps) => {
  const { hideModal } = useGlobalModalContext();

  return (
    <div className={styles.soon_feature_wrapper}>
      <div className={styles.header_wrapper}>
        <div>Thank you for using AudioModify</div>
        <div>{featureName} feature is still in development!</div>
      </div>
      <div className={styles.footer_wrapper}>
        <div>We’ll notify you at your email as soon as it’s ready for use.</div>
        <FilledButton text={"Got it!"} onClick={hideModal} />
      </div>
    </div>
  );
};

export default SoonFeatureModal;
